module.exports = __webpack_public_path__ + "static/media/onboarding-intro-logistics-finish.47577d73.svg";